'use client'

import { usePathname } from 'next/navigation'
import { createContext, useContext, useEffect, useRef, useState } from 'react'

const PreviousPageContext = createContext<string | null>(null)

export const PreviousPageProvider = ({ children }: { children: React.ReactNode }) => {
  const pathname = usePathname()
  const [previousPage, setPreviousPage] = useState<string | null>(null)
  const lastPathRef = useRef<string | null>(null)

  useEffect(() => {
    if (lastPathRef.current !== null) {
      setPreviousPage(lastPathRef.current)
    }
    lastPathRef.current = pathname
  }, [pathname])

  return (
    <PreviousPageContext.Provider value={previousPage}>{children}</PreviousPageContext.Provider>
  )
}

export const usePreviousPage = () => {
  const previousPage = useContext(PreviousPageContext)
  return previousPage
}
